import { render, staticRenderFns } from "./MenuWithTree.vue?vue&type=template&id=65cbcd3d&"
import script from "./MenuWithTree.vue?vue&type=script&lang=js&"
export * from "./MenuWithTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports